<div class="tile-card-structure forecast-master-table-block mt-4 uitk-c-card">
  <div class="forcast-tile">
    <div class="application-label">
      <p class="m-0">Forecast Master</p>
    </div>
    <div class="forecast-options">
      <button
        class="m-1 uitk-c-button uitk-c-button--default me-3 mat-mdc-raised-button techops-global-button uitk-u-margin-right--base uitk-u-margin-bottom--xs"
        (click)="onAdd()"
      >
        Add
      </button>
      <div class="export-link" (click)="exportToExcel()">
        <span
          title="Click to Download"
          class="uitk-icon uitk-icon-download md-icon excel_Download excelandinfo-Icon-font"
        ></span>
      </div>
    </div>
  </div>
  <div class="table-block mat-elevation-z8">
    <table
      mat-table
      [dataSource]="dataSource"
      class="mat-elevation-z8"
      multiTemplateDataRows
      matSort
      #empTbSort="matSort"
      (matSortChange)="sortData()"
    >
      <!-- Forecast Cycle Column -->
      <ng-container matColumnDef="Forecast_Cycle">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Forecast Cycle</th>
        <td mat-cell *matCellDef="let element">{{ element.Forecast_Cycle }}</td>
      </ng-container>

      <!-- Previous Column -->
      <ng-container matColumnDef="Previous">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Previous</th>
        <td mat-cell *matCellDef="let element">{{ element.Previous }}</td>
      </ng-container>

      <!-- Start Month Column -->
      <ng-container matColumnDef="FC_Start_Month">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>FC Start Month</th>
        <td mat-cell *matCellDef="let element">{{ element.FC_Start_Month }}</td>
      </ng-container>

      <!-- End Month Column -->
      <ng-container matColumnDef="FC_End_Month">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>FC End Month</th>
        <td mat-cell *matCellDef="let element">{{ element.FC_End_Month }}</td>
      </ng-container>
      <!-- Start Date Column -->
      <ng-container matColumnDef="Start_Date">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Start Date</th>
        <td mat-cell *matCellDef="let element">{{ element.Start_Date | date: 'MM/dd/yyyy' }}</td>
      </ng-container>
      <!-- weeks Column -->
      <ng-container matColumnDef="weeks">
        <th mat-header-cell *matHeaderCellDef>No of Weeks</th>
        <td mat-cell *matCellDef="let element">{{ element.weeks }}</td>
      </ng-container>
      <!-- Email Start Date Column -->
      <ng-container matColumnDef="Email_Start_Date">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Email Start Date</th>
        <td mat-cell *matCellDef="let element">{{ element.Email_Start_Date | date: 'MM/dd/yyyy' }}</td>
      </ng-container>
      <!-- End Date Column -->
      <ng-container matColumnDef="End_date">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>End Date</th>
        <td mat-cell *matCellDef="let element">{{ element.End_date | date: 'MM/dd/yyyy' }}</td>
      </ng-container>
      <!-- Admin End Date Column -->
      <ng-container matColumnDef="Admin_End_Date">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Admin End Date</th>
        <td mat-cell *matCellDef="let element">
          {{ (element.Admin_End_Date ? element.Admin_End_Date : element.End_date) | date: 'MM/dd/yyyy' }}
        </td>
      </ng-container>
      <!-- Updated By Column -->
      <ng-container matColumnDef="updatedBy">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Updated By</th>
        <td mat-cell *matCellDef="let element">{{ element.updatedBy }}</td>
      </ng-container>

      <!-- Updated At Column -->
      <ng-container matColumnDef="updatedAt">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Updated At</th>
        <td mat-cell *matCellDef="let element">{{ element.updatedAt | date: 'MM/dd/yyyy, h:mm a' }}</td>
      </ng-container>

      <ng-container matColumnDef="Action">
        <th mat-header-cell *matHeaderCellDef style="text-align: center;">Action</th>
        <td mat-cell *matCellDef="let element" style="text-align: center;">
          <span class="save-screen-icon" title="edit">
            <mat-icon class="icon-crud" (click)="onEdit(element)">edit</mat-icon>
          </span>
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>

    <mat-paginator [pageSize]="10" [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons> </mat-paginator>
  </div>
</div>

<ng-container>
  <app-modal
    [maximizable]="true"
    [inViewport]="true"
    #addEditForsecastMasterModal
    class="modal-demo add-forecast-modal"
    (closeModal)="closeModal()"
  >
    <ng-container class="app-modal-header">
      <div style="display: flex;width: 100%;">
        <div style="width: 98%;">
          Add Forecast
        </div>
        <div style="display: flex; align-items: center;"></div>
      </div>
    </ng-container>
    <ng-container class="app-modal-body">
      @if (showForecastModal) {
      <div>
        <app-add-edit-forecast-master
          [editData]="selectedEditData"
          [isEdit]="isEdit"
          [forecastCycleArr]="forecastCycleArr"
          (updateMasterTable)="refreshTableData()"
        ></app-add-edit-forecast-master>
      </div>
      }
    </ng-container>
  </app-modal>
</ng-container>
